export default {
  DIALOG: 'dialog',
  CONTENT: 'content',
};
